import "./config/sentry";
import { queryClient } from "./config/query";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider, Snackbar } from "@aidergroup/ui-v2";
import Alert from "./components/common/modals/alert";
import GlobalSpinner from "./components/ui/global-spinner";
import router from "./router";
import useLoadApp from "./hooks/useLoadApp";
import { QueryClientProvider } from "@tanstack/react-query";

const App: React.FC = () => {
    useLoadApp();

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <RouterProvider router={router} />
                <Alert />
                <Snackbar />
                <GlobalSpinner />
            </ThemeProvider>
        </QueryClientProvider>
    );
};

export default App;
